var React = require('react');

function IcLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M7.731 10.269a.876.876 0 0 1 0 1.278.907.907 0 0 1-1.278 0 4.503 4.503 0 0 1 0-6.363l3.186-3.186a4.503 4.503 0 0 1 6.363 0 4.503 4.503 0 0 1 0 6.363l-1.341 1.341a6.217 6.217 0 0 0-.36-2.178l.423-.432a2.684 2.684 0 0 0 0-3.816 2.684 2.684 0 0 0-3.816 0L7.731 6.453a2.684 2.684 0 0 0 0 3.816zm2.538-3.816a.907.907 0 0 1 1.278 0 4.503 4.503 0 0 1 0 6.363l-3.186 3.186a4.503 4.503 0 0 1-6.363 0 4.503 4.503 0 0 1 0-6.363l1.341-1.341a6.3 6.3 0 0 0 .36 2.187l-.423.423a2.684 2.684 0 0 0 0 3.816 2.684 2.684 0 0 0 3.816 0l3.177-3.177a2.684 2.684 0 0 0 0-3.816.876.876 0 0 1 0-1.278z"}));
}

IcLink.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = IcLink;

IcLink.default = IcLink;
